"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var colors_1 = require("../../../../constants/colors");
var icons_1 = require("../../../../constants/icons");
var molecules_1 = require("../../../molecules");
var SORT_TYPES = {
    ASC: 'ASC',
    DESC: 'DESC',
};
var TableSort = function (_a) {
    var id = _a.id, selectedSort = _a.selectedSort, setSelectedSort = _a.setSelectedSort, columnKey = _a.columnKey, trackMixpanel = _a.trackMixpanel;
    var handleSortClick = function (key) {
        if (id)
            trackMixpanel(id + "_" + key + "_SORT_CLICK", {});
        if (selectedSort.key === columnKey && selectedSort.sort_type === SORT_TYPES.ASC)
            setSelectedSort({
                key: key,
                sort_type: SORT_TYPES.DESC,
            });
        else if (selectedSort.key === columnKey && selectedSort.sort_type === SORT_TYPES.DESC)
            setSelectedSort({
                key: '',
                sort_type: '',
            });
        else
            setSelectedSort({
                key: columnKey,
                sort_type: SORT_TYPES.ASC,
            });
    };
    var isAsc = selectedSort.key === columnKey && selectedSort.sort_type === SORT_TYPES.ASC;
    var isDesc = selectedSort.key === columnKey && selectedSort.sort_type === SORT_TYPES.DESC;
    return (react_1.default.createElement("div", { className: 'tw-cursor-pointer tw-ml-1.5', onClick: function () { return handleSortClick(columnKey); }, role: 'presentation', "data-testid": "table-header-row-cell-sort-" + columnKey + "-" + id },
        react_1.default.createElement(molecules_1.SvgSpriteLoader, { id: 'chevron-up', className: '-tw-mb-0.5', iconCategory: icons_1.ICON_SPRITE_TYPES.ARROWS, color: isAsc ? colors_1.COLORS.TEXT_PRIMARY : colors_1.COLORS.TEXT_TERTIARY, width: 12, height: 12 }),
        react_1.default.createElement(molecules_1.SvgSpriteLoader, { id: 'chevron-down', iconCategory: icons_1.ICON_SPRITE_TYPES.ARROWS, color: isDesc ? colors_1.COLORS.TEXT_PRIMARY : colors_1.COLORS.TEXT_TERTIARY, width: 12, height: 12 })));
};
exports.default = TableSort;
